import { ActivationAPI } from '../api/ActivationAPI';

export const ActivationRepository = {
  activateUser: (contextData, usersData, processId) => ActivationAPI.activateUser(contextData, usersData, processId)
};